import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyReplayGuardToCurrentUrl } from "../utils/sentryReplayGuard";

export default function SentryReplayGuard() {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        applyReplayGuardToCurrentUrl();
    }, [pathname, search, hash]);

    return null;
}
